export default function Configure($stateProvider) {
    $stateProvider.state('fournisseurs', {
        parent: 'common',
        url: '/fournisseurs',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('fournisseurs.list', {
        url: '/:genre/list',
        template: '<sites></sites>',
        rights: { domain: 'sitefourn', right: 'read', application: 'gestion;performance;laboratoire' },
        ncyBreadcrumb: {
            parent: 'fournisseurs',
            label: '{{ "SITES.BREADCRUMBS.SITES_FOURNISSEURS_LIST" | translate}}'
        }
    });

    $stateProvider.state('fournisseurs.niveaux', {
        url: '/:genre/niveaux',
        template: '<site-config-niveaux></site-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher sites > niveaux
            parent: 'fournisseurs.list({genre: "fournisseurs"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('fournisseurs.list.detail', {
        url: '/:genre/{id}',
        template: '<site-detail></site-detail>',
        ncyBreadcrumb: {
            parent: 'fournisseurs.list({genre: "fournisseurs"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('fournisseurs.new', {
        url: '/:genre/new',
        template: '<site-form></site-form>',
        rights: { domain: 'sitefourn', right: 'create' },
        ncyBreadcrumb: {
            parent: 'fournisseurs.list({genre: "fournisseurs"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_NEW_FOURNISSEUR" | translate}}'
        },
        search: 'SITES.BREADCRUMBS.SITE_NEW_FOURNISSEUR'
    });

    $stateProvider.state('fournisseurs.edit', {
        url: '/:genre/{id}/edit',
        template: '<site-form></site-form>',
        rights: { domain: 'sitefourn', right: 'update' },
        ncyBreadcrumb: {
            parent: 'fournisseurs.list({genre: "fournisseurs"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_EDIT_FOURNISSEUR" | translate }}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
